import React from "react";
import { countryCodes } from "../../../CountryCodes";
import { Row, Label } from "reactstrap";
import { lazy } from "react";
import Editor, { EditorProvider } from "react-simple-wysiwyg";
// import {
//   resetFormState,
//   setAlternativePhoneOne,
//   setDescription,
//   setEmail,
//   setPhone,
//   setZipcode,
// } from "../../../../redux/slices/RequestFormSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Box,
  Grid,
  DialogContentText,
} from "@mui/material";
import NewlyEngagedForm from "../../../../pages/DashboardPages/settingsComponents/NewlyEngagedForm";
import InquiryOtherVendors from "./InquiryOtherVendors";

import { toast } from "react-toastify";
import {
  setAlternativePhoneOne,
  setDescription,
  setEmail,
  setPhone,
  setZipcode,
} from "../../../../redux/slices/InquirySlice";
import InquiryOtp from "./InquiryOtp";
import InquiryAnswers from "./InquiryAnswers";
import InquiryEvents from "./InquiryEvents";

const InquiryForm = ({
  islogin,
  dispatch,
  firstInputRef,
  selectedCountry,
  setSelectedCountry,
  emailError,
  setEmailError,
  zipcodeError,
  setZipcodeError,
  phoneError,
  setPhoneError,
  secondaryPhoneError,
  setSecondaryPhoneError,
  countryCodeError,
  setCountryCodeError,
  // descriptionError,
  // setDescriptionError,
  mandatoryQuestionsError,
  setMandatoryQuestionsError,
  eventDetailsError,
  setEventDetailsError,
  otherVendorsError,
  setOtherVendorsError,
  enquiryStep,
  otp,
  handleOtpChange,
  otpError,
  handleBack,
}) => {
  const formData = useSelector((state) => state.inquiry);
  const handleDesChange = (event) => {
    const value = event.target.value;
    dispatch(setDescription(value));
    // if (value.trim() !== "") {
    //   setDescriptionError(false);
    // }
  };
  const { sampleAd } = useSelector((state) => state.searchBar);
  console.log(formData, "formData");
  return (
    <>
      {enquiryStep === 1 && (
        <Grid container spacing={2}>
          {!islogin && (
            <Grid item xs={12} sm={12}>
              <TextField
                inputRef={firstInputRef}
                autoFocus
                margin="dense"
                id="Email"
                label="Enter Email"
                type="email"
                fullWidth
                variant="outlined"
                value={formData.Email}
                onChange={(e) => {
                  dispatch(setEmail(e.target.value));
                  setEmailError(false);
                }}
                placeholder="Enter Email ID"
                required
                error={emailError}
                helperText={emailError ? "Email is required" : ""}
                inputProps={{ required: true }}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={12}>
            <TextField
              margin="dense"
              id="Zipcode"
              label="Enter Zipcode"
              type="text"
              fullWidth
              variant="outlined"
              value={formData.Zipcode}
              onChange={(e) => {
                const zip = e.target.value.replace(/\D/g, "").slice(0, 5);
                dispatch(setZipcode(zip));
                setZipcodeError(false);
              }}
              placeholder="Enter 5-digit Zipcode"
              required
              error={zipcodeError}
              helperText={
                zipcodeError ? "Valid 5-digit zipcode is required" : ""
              }
              inputProps={{ required: true, maxLength: 5 }}
            />
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                // display: "flex",
                // flexDirection: { xs: "column", sm: "row" },
                alignItems: { xs: "stretch", sm: "flex-start" },
                gap: 2,
                width: "100%",
              }}
            >
              <FormControl
                variant="outlined"
                margin="dense"
                required
                error={countryCodeError}
                sx={{
                  width: "100%",
                  "& .MuiOutlinedInput-root": {
                    height: "56px",
                    fontSize: "0.9rem",
                  },
                }}
              >
                <InputLabel id="country-code-label" sx={{ fontSize: "0.9rem" }}>
                  Code
                </InputLabel>
                <Select
                  labelId="country-code-label"
                  id="country-code"
                  value={selectedCountry}
                  onChange={(e) => {
                    setSelectedCountry(e.target.value);
                    setCountryCodeError(false);
                  }}
                  label="Code"
                  renderValue={(value) => value}
                  MenuProps={{
                    PaperProps: {
                      sx: { maxHeight: 300, zIndex: 10000 },
                    },
                    PopperProps: {
                      sx: { zIndex: 10000 },
                    },
                  }}
                  sx={{
                    height: "56px",
                    "& .MuiSelect-select": {
                      padding: "16.5px 14px",
                    },
                  }}
                >
                  {countryCodes.map((country) => (
                    <MenuItem
                      key={country.code}
                      value={country.dial_code}
                      sx={{ fontSize: "0.9rem" }}
                    >
                      {`${country.name} (${country.dial_code})`}
                    </MenuItem>
                  ))}
                </Select>
                {countryCodeError && (
                  <FormHelperText sx={{ fontSize: "0.75rem" }}>
                    Country code required
                  </FormHelperText>
                )}
              </FormControl>
              <Box
                sx={{
                  // display: "flex",
                  // flexDirection: { xs: "column", sm: "row" },
                  gap: 2,
                  // width: { xs: "100%", sm: "auto" },
                  flexGrow: 1,
                }}
              >
                <TextField
                  margin="dense"
                  id="Phone"
                  label="Phone Number"
                  type="tel"
                  variant="outlined"
                  value={formData.Phone}
                  onChange={(e) => {
                    const phone = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 10);
                    if (
                      phone === formData.alternativePhoneOne &&
                      phone !== ""
                    ) {
                      setPhoneError(true);
                      toast.error(
                        "Phone number must be different from secondary phone number."
                      );
                      return;
                    }
                    dispatch(setPhone(phone));
                    setPhoneError(false);
                  }}
                  placeholder="Enter 10-digit Phone Number"
                  required
                  error={phoneError}
                  helperText={
                    phoneError ? "Valid 10-digit phone is required" : ""
                  }
                  inputProps={{ required: true, maxLength: 10 }}
                  sx={{
                    flex: 1,
                    width: "100%",
                    "& .MuiOutlinedInput-root": { height: "56px" },
                  }}
                />
                <TextField
                  margin="dense"
                  id="SecondaryPhone"
                  label="Secondary Phone Number"
                  type="tel"
                  variant="outlined"
                  value={formData.alternativePhoneOne}
                  onChange={(e) => {
                    const phone = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 10);
                    if (phone === formData.Phone && phone !== "") {
                      setSecondaryPhoneError(true);
                      toast.error(
                        "Secondary phone number must be different from primary phone number."
                      );
                      return;
                    }
                    dispatch(setAlternativePhoneOne(phone));
                    setSecondaryPhoneError(false);
                  }}
                  placeholder="Enter 10-digit Secondary Phone Number"
                  // required
                  error={secondaryPhoneError}
                  helperText={
                    secondaryPhoneError
                      ? "Valid 10-digit secondary phone is required"
                      : ""
                  }
                  inputProps={{ required: true, maxLength: 10 }}
                  sx={{
                    flex: 1,
                    width: "100%",
                    "& .MuiOutlinedInput-root": { height: "56px" },
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      )}
      {enquiryStep === 2 && (
        <>
          <Row>
            <InquiryEvents formData={formData} />
            {eventDetailsError && (
              <DialogContentText style={{ color: "red", marginTop: "10px" }}>
                Please fill in all event details.
              </DialogContentText>
            )}
          </Row>
        </>
      )}
      {enquiryStep === 3 && (
        <>
          {mandatoryQuestionsError && formData.engagedCouple === 1 && (
            <DialogContentText style={{ color: "red", marginTop: "10px" }}>
              Please answer all mandatory questions.
            </DialogContentText>
          )}
          <InquiryAnswers />
          <div className="decoration-editer">
            <Label style={{ fontSize: "14px" }}>
              Send a message to {sampleAd?.listName || sampleAd?.Title}{" "}
            </Label>
            <TextField
              margin="dense"
              id=""
              label=""
              type="textArea"
              fullWidth
              variant="outlined"
              value={formData?.Description || ""}
              multiline
              minRows={4}
              maxRows={8}
              onChange={handleDesChange}
              placeholder="E.g., I'm looking for a local plumber to fix a leaky faucet."
            />
            {/* <EditorProvider>
              <Editor
                value={formData?.Description || ""}
                onChange={handleDesChange}
                placeholder="E.g., I'm looking for a local plumber to fix a leaky faucet."
                // required
                style={{
                  border: `1px solid #ccc`,
                  borderRadius: "4px",
                  padding: "10px",
                  minHeight: "100px",
                }}
              />
            </EditorProvider> */}
          </div>
        </>
      )}
      {enquiryStep === 4 && (
        <InquiryOtherVendors
          otherVendorsError={otherVendorsError}
          setOtherVendorsError={setOtherVendorsError}
        />
      )}
      {enquiryStep === 5 && (
        <InquiryOtp
          firstInputRef={firstInputRef}
          otp={otp}
          handleOtpChange={handleOtpChange}
          otpError={otpError}
          handleBack={handleBack}
        />
      )}
    </>
  );
};

export default InquiryForm;
